import React from 'react';
import { observer } from 'mobx-react';
import { computed, observable } from 'mobx';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import InPlaceSelect from 'components/form/in_place_select';
import InPlaceText from 'components/form/in_place_text';
import { isPresent } from '@seedlang/utils';
import autobind from 'autobind-decorator';
import { Constants } from '@seedlang/constants';
import { WordStore, MeaningStore } from '@seedlang/stores';

@observer
class RegisterSelect extends React.Component {
  @observable showOtherInput = false;

  @computed get wordOrMeaning() {
    return this.props.meaning || this.props.word;
  }

  @computed get model() {
    return this.props.meaning ? 'meanings' : 'words';
  }

  @autobind setRegister(val) {
    if (val === 'other') {
      this.updateRegister('');
      this.showOtherInput = true;
    } else {
      this.showOtherInput = false;
      this.updateRegister(val);
    }
  }

  @autobind updateRegister(val) {
    this.wordOrMeaning.set('register', val);
    const store = this.props.meaning ? MeaningStore : WordStore;
    const data = { register: val };
    const ids = this.props.meaning ?
      { meaningId: this.wordOrMeaning.id } :
      { wordId: this.wordOrMeaning.id };

    store.update({ ids, data }, this.props.afterChange);
  }

  @computed get registerOptions() {
    const registerOptions = [];

    if (isPresent(this.wordOrMeaning.register) && !this.optionsContainValue(registerOptions, this.wordOrMeaning.register)) {
      this.addOption(registerOptions, this.wordOrMeaning.register, this.wordOrMeaning.register);
    }

    registerOptions.push(...Constants.REGISTER_OPTIONS);

    if ((this.props.word && this.props.word?.languageId === 'DE') || (this.props.meaning && this.props.meaning?.word?.languageId === 'DE')) {
      this.addOption(registerOptions, 'austrian', 'Austrian');
      this.addOption(registerOptions, 'swiss', 'Swiss');
    }

    this.addOption(registerOptions, 'other', 'Other...');

    return registerOptions;
  }

  @autobind optionsContainValue(options, val) {
    return options.some(opt => opt[0] === val);
  }

  @autobind addOption(options, val, label) {
    if (!this.optionsContainValue(options, val)) {
      options.push([val, label]);
    }
  }

  render() {
    if (isPresent(this.wordOrMeaning)) {
      if (this.showOtherInput) {
        return (
          <InPlaceText
            show
            model={this.model}
            field='register'
            id={this.wordOrMeaning.id}
            value={this.wordOrMeaning.register}
            placeholder='Enter custom register...'
          />
        );
      }

      return (
        <InPlaceSelect
          options={this.registerOptions}
          onChange={val => this.setRegister(val)}
          includeBlank
          value={this.wordOrMeaning.register}
        />
      );
    }
    return <div />;
  }
}

export default ErrorBoundary(RegisterSelect);
